export class DateIdentificacionModel {
    Desde: Date;
    Hasta: Date;
}